export const ACCESS_TOKEN_KEY = 'ac'
export const REFRESH_TOKEN_KEY = 'rf'